export const entityText={
    accounts : 'View & revoke consents given for your own bank, demat, incurance, etc accounts',
    apps : 'View & revoke consents given to third party apps & websites for personal finance magangement, loan monitoring, etc'
}